"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./alignment"), exports);
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./~/pdf-lib/cjs/api/image/index.js